/** @format */

import React, { FunctionComponent, useState } from 'react';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { PlkStatusMap } from '../../../helpers/iccidStatus';
import { Auth } from '../../../modules/auth/Auth';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { ProductRemoveNotPortingPrepare } from './ProductRemoveNotPortingPrepare';
import { ProductBreakRemove } from './ProductBreakRemove';
import { ProductRemovePorting } from './ProductRemovePorting';

export type ProductRemoveType = {
    product: SimCardInterface;
    itemLoader: ItemLoaders;
    classes: any;
};

export const ProductRemove: FunctionComponent<ProductRemoveType> = ({ product, itemLoader, classes }) => {
    const [openDelete, setOpenDelete] = useState(false);
    const [openBreakDelete, setOpenBreakDelete] = useState(false);
    const deleteProduct =
        (product.mvnoStatus > PlkStatusMap.PREACTIVATED && product.mvnoStatus !== PlkStatusMap.CANCELLED && product.removePeriod === null) ||
        Auth.isExpertMode();
    const deleteProduktCancel =
        (product.mvnoStatus > PlkStatusMap.PREACTIVATED && product.mvnoStatus !== PlkStatusMap.CANCELLED && product.removePeriod !== null) ||
        (product.mvnoStatus === PlkStatusMap.CANCELLED && Auth.isExpertMode());

    const prepareDeleteProduct = (): void => {
        setOpenDelete(true);
    };

    const prepareDeleteProduktCancel = (): void => {
        setOpenBreakDelete(true);
    };

    return (
        <React.Fragment>
            {deleteProduct && (
                <React.Fragment>
                    <CustomTextButtom
                        callback={prepareDeleteProduct}
                        callbackParam={{}}
                        label={deleteProduktCancel ? 'simcard:v.cancel_product_change_date' : 'simcard:v.cancel_product'}
                        size="sm"
                    />
                    {/*{product.isPorted && (*/}
                    {/*    <ProductRemovePorting*/}
                    {/*        product={product}*/}
                    {/*        itemLoader={itemLoader}*/}
                    {/*        classes={classes}*/}
                    {/*        open={openDelete}*/}
                    {/*        setOpenDialog={setOpenDelete}*/}
                    {/*    />*/}
                    {/*)}*/}
                    {/*{!product.isPorted && (*/}
                    <ProductRemoveNotPortingPrepare
                        classes={classes}
                        product={product}
                        itemLoader={itemLoader}
                        open={openDelete}
                        setOpenDialog={setOpenDelete}
                    />
                    {/*)}*/}
                </React.Fragment>
            )}
            {deleteProduktCancel && (
                <React.Fragment>
                    <CustomTextButtom callback={prepareDeleteProduktCancel} callbackParam={{}} label="simcard:edit.cancel_delete_process" size="sm" />
                    <ProductBreakRemove
                        product={product}
                        itemLoader={itemLoader}
                        classes={classes}
                        open={openBreakDelete}
                        setOpenDialog={setOpenBreakDelete}
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    );
};
